import React, { useState } from 'react';
import { Paper, TableContainer, Grid, useMediaQuery, useTheme, Box, Typography } from '@mui/material';
import TableListHeader from './TableListHeader';
import TableListItem from './TableListItem';
import InventoryResponsiveCard from './InventoryResponsiveCard';
import CustomPagination from '../../Pagination';
import { useSelector } from 'react-redux';
import FilterToolbar from './FilterToolbar';

const InventoryTableView = ({ 
  data, setOpenDialog, searchQuery,
  availableCategories, availableTags, 
  selectedCategories, selectedTags,
  setSelectedCategories, setSelectedTags 
}) => {
  const theme = useTheme();
  const isTableView = useMediaQuery(theme.breakpoints.up('md')); // Use table view on medium and larger screens

  const handleCategoryChange = (event) => {
    const { target: { value } } = event;
    setSelectedCategories(typeof value === 'string' ? value.split(',') : value);
  };

  const handleTagChange = (event) => {
    const { target: { value } } = event;
    setSelectedTags(typeof value === 'string' ? value.split(',') : value);
  };

  const uniqueCategoryNames = availableCategories.map(cat => cat.name || cat);
  const hasData = data && data.length > 0;

  return (
    <>
       <FilterToolbar
        uniqueTags={availableTags}
        uniqueCategories={uniqueCategoryNames}
        selectedTags={selectedTags}
        selectedCategories={selectedCategories}
        handleTagChange={handleTagChange}
        handleCategoryChange={handleCategoryChange}
      />
      
      {!hasData ? (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ py: 10, width: '100%' }}>
            <img src={require('../../../utilities/dummy_assets/nodatafound.jpg')} alt="No Data Found" style={{ width: 'auto', maxHeight: '250px', marginBottom: '16px' }} />
            <Typography variant="h5" color="textSecondary" sx={{ fontWeight: 500 }}>
                No inventory items match these filters
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mt: 1 }}>
                Try adjusting your categories or tags to see more results.
            </Typography>
        </Box>
      ) : isTableView ? (
        // Table View for Medium and Larger Screens
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            border: '0.5px solid rgba(181, 181, 181, 1)',
            background:
              'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, #B5B5B5, #B5B5B5)',
            boxShadow: 'none',
            ml: '1rem',
            width: '95%',
            borderRadius: '8px',
            mr: '1rem',
            mb: 4
          }}
        >
          <TableListHeader />
          {data && data.map((product) => (
            <TableListItem
              key={product.id}
              product={product}
              setOpenDialog={setOpenDialog}
              searchQuery={searchQuery}
            />
          ))}
        </TableContainer>
      ) : (
        // Card View for Small and Medium Screens
        <Grid container spacing={2} sx={{ padding: '16px', mb: 4 }}>
          {data && data.map((product) => (
            <Grid item xs={12} sm={6} key={product.id}>
              <InventoryResponsiveCard product={product} searchQuery={searchQuery} />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default InventoryTableView;
